import { Accessibility, HardDriveDownload, Info, Languages, LockKeyhole, RefreshCw } from 'lucide-react';
import { NavLink, Outlet } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export function SettingsLayout() {
  const { t } = useTranslation();
  return (
    <>
      <section className="content-wrap page-hero">
        <div className="page-heading"><div><h1>{t('settings.title')}</h1><p>{t('settings.description')}</p></div></div>
      </section>
      <div className="content-wrap settings-layout">
        <nav className="settings-nav" aria-label={t('settings.title')}>
          <NavLink to="/settings" end><Languages size={17} aria-hidden="true" />{t('settings.sections.general')}</NavLink>
          <NavLink to="/settings/offline-storage"><HardDriveDownload size={17} aria-hidden="true" />{t('settings.sections.offlineStorage')}</NavLink>
          <NavLink to="/settings/privacy"><LockKeyhole size={17} aria-hidden="true" />{t('settings.sections.privacyData')}</NavLink>
          <NavLink to="/settings/accessibility"><Accessibility size={17} aria-hidden="true" />{t('settings.sections.accessibility')}</NavLink>
          <NavLink to="/settings/updates"><RefreshCw size={17} aria-hidden="true" />{t('settings.sections.updates')}</NavLink>
          <NavLink to="/settings/about"><Info size={17} aria-hidden="true" />{t('settings.sections.about')}</NavLink>
        </nav>
        <div className="settings-content"><Outlet /></div>
      </div>
    </>
  );
}
